
import { Component, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { UserModule } from '@/store/modules/user';
import { DeviceType, AppModule } from '@/store/modules/app';
import { AppMain, Navbar, Sidebar } from './components';
import ResizeMixin from '../layout/mixin/resize';

@Component({
  name: 'LayoutAgent',
  components: {
    AppMain,
    Navbar,
    Sidebar
  }
})
export default class extends mixins(ResizeMixin) {
  created() {
  }

  get classObj() {
    return {
      openSidebar: this.sidebar.opened,
      withoutAnimation: this.sidebar.withoutAnimation,
      mobile: this.device === DeviceType.Mobile
    };
  }

  get themeClass() {
    return AppModule.themed;
  }

  // private handleClickOutside() {
  //   AppModule.CloseSideBar(false);
  // }
}
